import { NgModule, ModuleWithProviders } from '@angular/core';
import { AngularFireModule, FirebaseAppConfig } from 'angularfire2';
import { AngularFirestore } from 'angularfire2/firestore';

import { ExtendedAngularFirestore } from './extended-angular-firestore';
export class ExtendedAngularFirestoreModule {
/**
 * @param {?} config
 * @return {?}
 */
static forRoot(config: FirebaseAppConfig): ModuleWithProviders {
class RootModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
            imports: [ AngularFireModule.initializeApp(config) ]
        }, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RootModule_tsickle_Closure_declarations() {
/** @type {?} */
RootModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RootModule.ctorParameters;
}

        return {
            ngModule: RootModule,
            providers: [ ExtendedAngularFirestore ]
        };
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ExtendedAngularFirestoreModule_tsickle_Closure_declarations() {
/** @type {?} */
ExtendedAngularFirestoreModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExtendedAngularFirestoreModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
